const messages = {
  en: {
    title: 'Issue Resolved',
    help: "We're glad we could help!",
    close: 'Close'
  },
  'es-ud': {
    title: 'Problema Resuelto',
    help: 'Nos alegra poder ayudarle.',
    close: 'Cerrar'
  },
  es: {
    title: 'Problema Resuelto',
    help: 'Nos alegra poder ayudarte.',
    close: 'Cerrar'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/IssueResolvedModal/messages.js